import React from 'react'
import styled from 'styled-components'
import Button from '../Button'

const Container = styled.div`
  padding-bottom: 5rem;
`

const InnerContainer = styled.div`
  padding: 1rem 3rem;
  background-color: ${props => props.theme.colors.white};
  box-shadow: ${props => props.theme.boxShadow.navbar};
  border-bottom: ${props => props.theme.borders.grey13};
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;

  @media (max-width: 500px) {
    padding: 1rem 15px;
  }
`

const A = styled.a`
`

const Logo = styled.img`
  height: 30px;
  width: 120px;
`

export default () => (
  <Container>
    <InnerContainer>
      <A href='https://planswell.com' target='_blank' rel='noopener'>
        <Logo src='/planswell-logo-green.svg' />
      </A>
      <Button
        as='a'
        href='https://my.planswell.ca/discovery/ORG-CAC'
        target='_blank'
        small
        width='inherit'
        padding='11px 20px'
        fontSize='1rem'
      >
        Start now
      </Button>
    </InnerContainer>
  </Container>
)
